import React from 'react'
import { Navigate, Outlet } from 'react-router-dom';
import { isLogin } from '../services/CheckAuthentication';

const ProtectedRoutes = () => {
    return isLogin() ? <Outlet /> : <Navigate  to="/" />;
}

export default ProtectedRoutes